import React, { useMemo, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiTextColor} from '@elastic/eui';
import {ComboTiposFuncionContainer as ComboTiposFuncion} from "../../../components/Combos/TiposFuncion/container";
import {ComboConceptosFacturacionContainer as ComboConceptosFacturacion} from '../../../components/Combos/ConceptosFacturacion/container';

export const Formulario = (props)=>{

  let {onSave, selected, onClose} = props
  
  let [subFuncion,setSubFuncion] = useState(selected ? selected.subFuncion : undefined)
  let [tipo,setTipo] = useState(selected ? selected.idTipo : [])
  let [concepto, setConcepto] = useState(selected ? selected.idConcepto : [])
  
  const getData = () =>{
    let data={subFuncion: subFuncion, idTipo: (Array.isArray(tipo) ? tipo[0].value : tipo), idConcepto: (Array.isArray(concepto) ? concepto[0].value : concepto)};
    if(selected){
      return {...selected,...data}
    }else{return data}
  }

  const onSaveData = () =>{
    if(!comprobarErrores()){
      let newData = getData();
      onSave && onSave(newData)
    }
  }

  const comprobarErrores = () => {
    return (isInvalidSubFuncion || isInvalidTipo || isInvalidConcepto)
  }

  const isInvalidSubFuncion = useMemo(() => {return subFuncion===undefined || subFuncion.trim()===""},[subFuncion])
  const isInvalidTipo = useMemo(() => {return tipo.length===0},[tipo])
  const isInvalidConcepto = useMemo(() => {return concepto.length===0},[concepto])

  return (
    <>
    <EuiFlexGroup>
      <EuiFlexItem>
          <EuiFormRow fullWidth label="SubFunción" isInvalid={isInvalidSubFuncion}>
            <EuiFieldText fullWidth value={subFuncion} name="txtSubFuncion" onChange={e => setSubFuncion(e.target.value)} isInvalid={isInvalidSubFuncion}/>
          </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Tipo" isInvalid={isInvalidTipo}>
          <ComboTiposFuncion fullWidth selectedOptions={tipo} onChange={value =>{setTipo(value)}} isInvalid={isInvalidTipo}/>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Concepto Facturación" isInvalid={isInvalidConcepto}>
          <ComboConceptosFacturacion fullWidth selectedOptions={concepto} onChange={value => {setConcepto(value)}} isInvalid={isInvalidConcepto}/>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>

    {comprobarErrores() ? 
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="">
          <EuiTextColor color="danger"><br/>{"Faltan campos por rellenar"}</EuiTextColor>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    :null}
    <EuiSpacer size="m" />

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiButton onClick={onSaveData} disabled={comprobarErrores()}>
          Guardar
        </EuiButton>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiButton color="danger" onClick={()=>onClose()}>Cancelar</EuiButton>
      </EuiFlexItem>
    </EuiFlexGroup>
    </>
      
  )
}
export default Formulario;